<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false,
    labels: { fontFamily },
  },
  animation: { duration: 0 },
  elements: {
    line: { tension: 0.4 },
    point: { radius: 3, hoverRadius: 5 },
  },
  scales: {
    x: {
      ticks: { fontFamily },
      grid: { drawOnChartArea: false },
    },
    y: {
      type: 'linear',
      position: 'left',
      ticks: { fontFamily, beginAtZero: true, stepSize: 1 },
      grid: { drawOnChartArea: false },
    },
  },
};

const options = computed(() => ({
  ...defaultChartOptions,
  ...props.chartOptions,
}));
</script>

<template>
  <Line :data="collection" :options="options" />
</template>
